export class VendorLineItemTemplateRawDto {
    associationVendorId: number;
    vendorAccountId: number; // 	NOTE: This is null for vendor level template
    templateId: number; // NOTE: This is used when verifying or approving work flow
    enabled: boolean; // NOTE: Indicates if the template is enabled. Should be used in work flow only if enabled
    sequence: number; // 	NOTE: Indicates the order when importing line items
    itemAmount: number; // NOTE: Indicates line item amount
    description: string;
    subAccountId: number; // NOTE: This is used when verifying or approving work flow
    subCategoryId: number; // NOTE: This is used when verifying or approving work flow
    dimensions: string; // NOTE: This is used when verifying or approving work flow
}
